// Maintenance Mode Configuration
export const MAINTENANCE_CONFIG = {
  enabled: false,
  // Target date 7 days from now (April 19, 2026)
  targetDate: new Date('2026-04-19T00:00:00+05:00').getTime(),
  supportEmail: 'support@moizwp.com',
  message: "We're currently polishing our experience to serve you better. Our team is working hard behind the scenes to bring you something truly exceptional."
};
